import { Box, styled } from '../../../../base-components';
import { getImageRatio } from './utils';
import { ImageRatio } from './interfaces';

export const StyledRatioBox = styled(Box)<{ ratio: ImageRatio }>(
    ({ ratio }) => ({
        width: 1,
        lineHeight: 1,
        display: 'block',
        overflow: 'hidden',
        position: 'relative',
        pt: getImageRatio(ratio),
        '& .wrapper': {
            top: 0,
            left: 0,
            width: 1,
            height: 1,
            position: 'absolute',
            backgroundSize: 'cover !important',
        },
    })
);

export const StyledBox = styled(Box)(() => ({
    lineHeight: 1,
    display: 'block',
    overflow: 'hidden',
    position: 'relative',
    '& .wrapper': {
        width: 1,
        height: 1,
        backgroundSize: 'cover !important',
    },
}));
